// src/App.js

import React from 'react';
import StoreClosureForm from './StoreClosureForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Store Closure Notification</h1>
      </header>
      <main>
        <StoreClosureForm />
      </main>
    </div>
  );
}

export default App;
